import React, {memo, Suspense} from "react"
import {MANIFEST} from "@manifest/plp"
import {useTemplatedComponent} from "@next/templating"
import connect from "./connect"

interface InjectedAdProps {
    templating: {
        mainTemplate: string
        fallbackTemplate: string
    }
    injectedAdEnvironment: string
}

export const InjectedAd = memo(({templating, injectedAdEnvironment}: InjectedAdProps) => {
    const ComponentName = useTemplatedComponent(templating, MANIFEST)

    return (
        <Suspense>
            <ComponentName injectedAdEnvironment={injectedAdEnvironment} />
        </Suspense>
    )
})
InjectedAd.displayName = "InjectedAd"

export default connect(InjectedAd)
